<div class="container-fluid hero-section">
  <div class="row align-items-center">
    <!-- Left: Content -->
    <div class="col-lg-6 col-md-12 hero-content">
      <div class="hero-line"></div>
      <h1>
        MALtech uses quantum algorithms and expertise to drive breakthroughs
        beyond classical computing.
      </h1>
      <p>
        MALtech is at the forefront of innovation, driving the next era of
        computing with quantum technology. We harness its power to process
        complex problems with unmatched speed and intelligence. Our solutions
        enable businesses to operate smarter, faster, and more securely.
      </p>
      <div class="hero-actions">
  <button (click)="getStart()" class="btn hero-btn">
    Why Choose Us
  </button>
    
         <a
      [routerLink]="['/contact']"
      [attr.href]="'/contact'"
      rel="noopener noreferrer"
      class="btn hero-btn  btn-lg" aria-label="Let's Work Together"
    >
     Let's Work Together
    </a>
    </div>
    </div>

    <!-- Right: Image -->
    <div class="col-lg-6 col-md-12 hero-image text-center mt-4">
      <img
        src="assets/images/quantum-computing/quantum-computing.webp"
        alt="Quantum Computing Illustration"
        class="img-fluid"
        width="550"
        loading="lazy"
      />
    </div>
  </div>
</div>

<!-- What is Quantum Computing? -->

<div class="container-fluid quantum-section">
  <div class="row mb-4">
    <div class="col-12 text-center">
      <h2>What is Quantum Computing?</h2>
      <p class="justify-text mx-auto">
        Quantum computing uses the principles of quantum mechanics to solve
        problems classical computers cannot. MALtech helps businesses apply this
        technology for innovation and growth.
      </p>
    </div>
  </div>

  <!-- Quantum Cards -->
  <div class="row mt-4">
    <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
      <div class="quantum-card">
        <h5>Quantum Speed</h5>
        <p>
          Quantum systems process complex computations exponentially faster
          than classical machines.
        </p>
      </div>
    </div>

    <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
      <div class="quantum-card">
        <h5>Unmatched Accuracy</h5>
        <p>
          Leveraging quantum states enables higher precision in optimization
          and simulation problems.
        </p>
      </div>
    </div>

    <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
      <div class="quantum-card">
        <h5>Future-Ready Security</h5>
        <p>
          Quantum cryptography provides next-generation protection against
          cyber threats.
        </p>
      </div>
    </div>
  </div>
</div>


<!-- Industries serve-->
<div class="container-fluid industries-section">
  <div class="row">
    <div class="col-12 text-center">
      <h2>Industries We Transform with Quantum</h2>
    </div>
  </div>

  <div class="row">
    <div
      class="col-lg-4 col-md-6 col-sm-12 mb-4"
      *ngFor="let industry of industries"
    >
      <div class="industry-card text-center">
        <h5>{{ industry.title }}</h5>
        <p>{{ industry.description }}</p>
      </div>
    </div>
  </div>
</div>

<!-- Approach -->
<div class="container-fluid approach-section">
  <div class="row justify-content-center">
    <div class="col-12">
      <h2 class="text-center">Our Approach</h2>
      <p class="intro text-center">
        Our approach to quantum computing is collaborative and results-oriented,
        focusing on delivering tangible value to our clients. We work closely
        with you to understand your specific needs and tailor our solutions
        accordingly.
      </p>
    </div>
  </div>

  <div class="row">
    <div class="col-md-8">
      <div class="timeline">
        <div
          class="timeline-step"
          *ngFor="let step of steps; let i = index"
          (mouseenter)="setActive(i)"
          (mouseleave)="clearActive()"
        >
          <div class="icon-wrapper" [class.active]="i <= activeIndex">
            <i class="bi" [ngClass]="step.icon"></i>
          </div>
          <div class="content">
            <h5>{{ step.title }}</h5>
            <p>{{ step.description }}</p>
          </div>
          <div class="line" [class.active]="i <= activeIndex"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Why Maltech -->

<div class="container-fluid why-choose" id="get-start">
  <div class="row text-center mb-5 mt-5">

    <div class="col-12">
      <h2>Why Choose MALtech</h2>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-md-6 col-lg-3 mb-4" *ngFor="let feature of features">
      <div class="feature-card h-100 d-flex flex-column text-center">
        <div class="icon"><i class="bi" [ngClass]="feature.icon"></i></div>
        <h5>{{ feature.title }}</h5>
        <p>{{ feature.description }}</p>
      </div>
    </div>
  </div>
</div>

<!-- FAQs and Contact Us-->

<div class="container-fluid faq-section py-5">
  <!-- Heading -->
  <div class="row mb-4 text-center">
    <div class="col-12">
      <h2>Frequently Asked Questions</h2>
    </div>
  </div>

  <!-- Accordion -->
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-8">
      <div class="accordion" id="faqAccordion">
        <div class="accordion-item" *ngFor="let item of faqs; let i = index">
          <h2 class="accordion-header" id="heading{{ i }}">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#collapse' + i"
              aria-expanded="false"
              [attr.aria-controls]="'collapse' + i"
            >
              {{ item.question }}
            </button>
          </h2>
          <div
            [id]="'collapse' + i"
            class="accordion-collapse collapse"
            [attr.aria-labelledby]="'heading' + i"
            data-bs-parent="#faqAccordion"
          >
            <div class="accordion-body">
              {{ item.answer }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- CTA -->
  <div class="row text-center mt-5">
    <div class="col-12">
      <h3 class="cta-text">
        Ready to unlock the power of <span>Quantum?</span>
      </h3>
      <p>Contact MALtech today and start your journey.</p>
      <a
      [routerLink]="['/contact']"
      [attr.href]="'/contact'"
      rel="noopener noreferrer"
      class="btn btn-outline-primary btn-lg mt-3" aria-label="Contact Us"
    >
      Contact Us 
    </a>

    </div>
  </div>
</div>
